import React from 'react';
import LifecycleRuleDetailSection from '../../../sections/AdminDashboard/Configuration/LifecycleRuleDetail';

const LifecycleRuleDetail = () => <LifecycleRuleDetailSection />;

export default LifecycleRuleDetail;
